import PlaybackSpeed from "./enums/PlaybackSpeed";
import PlaybackState from "./types/PlaybackState";

// Wall-clock duration of a full-range playback at 1x. Provisional — may be tuned after feedback.
export const PLAYBACK_DURATION_MS = 10000;

// Order the speed button steps through, wrapping back to the first after the last.
export const PLAYBACK_SPEED_CYCLE: PlaybackSpeed[] = [
  PlaybackSpeed.Full,
  PlaybackSpeed.Half,
  PlaybackSpeed.Quarter,
];

// Cadence for committing an in-progress scrub to the store. Fast enough that the map's paused avatar
// and revealed pins visibly follow the dragging handle, slow enough that the per-commit map re-render
// doesn't stall the drag. The exact final position is always committed on release.
export const SCRUB_COMMIT_THROTTLE_MS = 100;

// Resting playback value — not playing, parked at the end; this is the Idle status.
export const IDLE_PLAYBACK_STATE: PlaybackState = { isPlaying: false, progress: 1 };
